import Footer from "./footer";
import Contact from "./contact";

function ContactPage(){
    return(
        <> 
        <Contact/>
         <Footer/>
        </>
    );
}
export default ContactPage;